import request from "@/utils/request.js"

// 新增门店分组
export const addStoreGroup = (formData) => {
    return request.post('/storeGroup', formData)
}

// 获取门店分组列表
export const listStoreGroup = (pageData, formData) => {
    return request.get(`/storeGroup/storeGroupPage/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 删除门店分组
export const removeStoreGroup = (id) => {
    return request.delete(`/storeGroup/${id}`)
}

// 新增网店分组
export const addOnlineStoreGroup = (formData) => {
    return request.post('/storeGroup/onlineStoreGroup', formData)
}

// 获取网店分组列表
export const listOnlineStoreGroup = (pageData, formData) => {
    return request.get(`/storeGroup/onlineStoreGroupPage/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 删除网店分组
export const removeOnlineStoreGroup = (id) => {
    return request.delete(`/storeGroup/onlineStoreGroup/${id}`)
}

//  门店-商品分组列表
export const listPostStoreGoodsGroup = () => {
    return request.get(`/storeGroup/storeGroupList`)
}

//  网店-商品分组列表
export const listOnlineStoreGoodsGroup = () => {
    return request.get(`/storeGroup/onlineStoreGroupList`)
}